/**
 * returns if the window is defined, used for determining browser vs node
 */
export const HAS_WINDOW = typeof window !== "undefined";
